import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Collapse from 'components/Collapse';
import Details from './Details';
import Section from '../Section';
import { joinPath } from 'utils/path';
function Languages({ className, editPath, indexedMeta, languages }) {
  const location = useLocation();
  
  const path = useMemo(() => {
    return editPath ? joinPath(editPath, 'languages') : '';
  }, [editPath]);

  const editPathState = useMemo(() => ({ background: location }), [location]);

  return (
    <Section className={className} editPath={path} editPathState={editPathState} title="title.languages">
      {/* Boolean conversion needed to avoid displaying "0" when length is 0 */}
      {!!languages.length && (
        <Collapse>
          {languages.map(language => (
            <Details indexedMeta={indexedMeta} key={language.id} language={language} />
          ))}
        </Collapse>
      )}
    </Section>
  );
}

Languages.propTypes = {
  className: PropTypes.string,
  editPath: PropTypes.string,
  indexedMeta: PropTypes.object.isRequired,
  languages: PropTypes.array.isRequired
};

export default Languages;
